import React, { ReactNode } from 'react';
import styled from 'styled-components';

import CheckImg from '../assets/check.svg';

const Wrapper = styled.div<{ disabled?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 6px 0;opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

type BoxProps = {
  checked: boolean;
  disabled?: boolean;
}

const Box = styled.div<BoxProps>`
  margin-right: 10px;
  width: 15px;
  height: 15px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // background-color: ${({ theme, checked }) => (checked ? theme.colors.primary : theme.colors.basic100)};
  background-color: ${({ checked, disabled }) => 
    disabled ? "#d3d3d3" : checked ? "#95d0dd" : "white"};
  border: 1px solid ${({ checked, disabled }) => 
    disabled ? "#c5c5c5" : checked ? "transparent" : "#c5c5c5"};
  border-radius: 2px;
  cursor: pointer;
`;

const Check = styled.img`
  width: 8px;
  height: 8px;
`;

const CheckText = styled.p`
  font-size: 12px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.basic1000};
`;

type CheckboxProps = {
  checked: boolean;
  handleChange: () => void;
  text: ReactNode | string;
  disabled?: boolean;
}

const Checkbox = ({
  checked, handleChange, text, disabled = false
}: CheckboxProps) => (
  <Wrapper disabled={disabled} onClick={() => !disabled && handleChange()}>
    <Box checked={checked}>
      {checked && <Check src={CheckImg} alt="Aceptado" />}
    </Box>
    <CheckText>
      {text}
    </CheckText>
  </Wrapper>
);

export default Checkbox;